import _import from '../lazy-importer';
import Layout from '@/views/console/jdbc/layout/Layout';
import { setDatabaseType } from '@/utils/helpers';

const basicPath = `/console/jdbc`;

const routes = [
  {
    path: `${basicPath}`,
    component: Layout,
    redirect: { name: 'JdbcIndex' },
    children: [
      {
        path: 'index',
        name: 'JdbcIndex',
        component: _import('console/jdbc/static/Index'),
        meta: { title: '首页' }
      },
      {
        path: 'table_view',
        name: 'JdbcTableView',
        component: _import('console/jdbc/static/TableView'),
        meta: { title: '表视图' }
      }
    ]
  },
  {
    path: `${basicPath}/sql`,
    name: 'JdbcSql',
    component: Layout,
    redirect: { name: 'JdbcSqlWindow' },
    meta: { title: 'SQL 操作', inNav: true },
    children: [
      {
        path: 'window',
        name: 'JdbcSqlWindow',
        component: _import('console/jdbc/sql/Window'),
        meta: { title: 'SQL 窗口', inNav: true }
      }
    ]
  }
];

export default setDatabaseType(routes, 'MYSQL');
